import type { ToolDefinition } from '../types';
import { LutPanel } from './panel';
import { DEFAULT_LUT_PARAMS, LUT_CATEGORIES, normalizeLutParams, type LutParams } from './types';

export const lutTool: ToolDefinition<LutParams> = {
    id: 'lut',
    label: 'tool.lut.name',
    defaultParams: DEFAULT_LUT_PARAMS,
    normalize: normalizeLutParams,
    Panel: ({ params, onChange }) => <LutPanel params={params} onChange={onChange} />,
    onRun: async ({ params, now }) => {
        const MODEL_ID = 'davinci';
        const presetName =
            LUT_CATEGORIES.flatMap((c) => c.luts).find((l) => l.id === params.lut_name)?.name ??
            'DaVinci';

        return {
            createGraph: {
                nodes: [
                    {
                        key: 'image',
                        type: 'image',
                        data: {
                            // This controls the node title (EditableNodeTitle reads data.name).
                            name: presetName,
                            viewMode: 'transform',
                            model: MODEL_ID,
                            modelUi: {
                                lut: params.lut_name,
                                intensity: params.intensity,
                                source_image_url: params.source_image_url,
                            },
                            updatedAt: now,
                            generated: undefined,
                            status: undefined,
                            processingTaskId: undefined,
                            processingGenerationId: undefined,
                        } as any,
                    },
                ],
                edges: [],
                selectKey: 'image',
                autoRunKey: 'image',
            },
            connectFromSource: true,
            autoRun: true,
        };
    },
};

export type { LutParams };
export { DEFAULT_LUT_PARAMS, normalizeLutParams };
